import { clientLanguageGuess } from './clientContext'
import { normalizeLanguageCode, type AppLanguage } from '../i18n/languages'

const STORED_LANGUAGE_KEY = 'kilo_language_preference'

export function readStoredLanguagePreference(): AppLanguage | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(STORED_LANGUAGE_KEY)
    if (!raw) return null
    return normalizeLanguageCode(raw)
  } catch {
    return null
  }
}

export function writeStoredLanguagePreference(language: AppLanguage): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORED_LANGUAGE_KEY, normalizeLanguageCode(language))
  } catch {
    // ignore quota / private mode errors
  }
}

/** Language for signed-out flows: explicit picker choice, then browser guess. */
export function resolveAnonymousLanguage(): AppLanguage {
  return readStoredLanguagePreference() ?? clientLanguageGuess()
}
